 const scrollTopBtn = document.querySelector(".scroll_to_top");

        // Show button when scrolling down
        window.onscroll = function () {
            if (document.documentElement.scrollTop > 200) {
                scrollTopBtn.style.display = "inline-flex";
            } else {
                scrollTopBtn.style.display = "none";
            }
        };

        // Scroll to top when button is clicked
        scrollTopBtn.addEventListener("click", function () {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });


class MarqueWebComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeSplide(); 
  }

  initializeSplide() {
    const marqueElement = this.querySelector('.marque');
    const marque = new Splide(marqueElement, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      arrows: false,
      pagination: false,
      perPage: 4,
      autoWidth: true,
      autoScroll: {
        speed: 1,
      },
      breakpoints: {
        767: {
          perPage: 3,
        },
        576: {
          perPage: 2,
        }
      },
    });

    marque.mount(window.splide.Extensions);
  }
}

customElements.define('marque-component', MarqueWebComponent);




const sliders = document.querySelectorAll('.collection_splide');


if (sliders.length > 0) {
  [...sliders].forEach(slider => {
    new Splide(slider, {
      type       : 'slide',       
      perPage    : 4,
      gap        : '31px',
      perMove    : 1, 
      drag       : true,
      pagination : false,         
      arrows     : true,        
      breakpoints: {             
        479: {
          perPage: 1,
          pagination : false,         
          arrows     : true,
          drag       : true,
        },          
        767: {
          perPage: 2,
          pagination : false,         
          arrows     : true,
          drag       : true,
        },
        1199: {
          perPage: 3,
          pagination : false,         
          arrows     : true,
          drag       : true,
          gap        : '20px',
        },
      },
    }).mount();
  });
}


const reviewSliders = document.querySelectorAll('.review_slider_splide');


if (reviewSliders.length > 0) {
  [...reviewSliders].forEach(slider => {
    new Splide(slider, {
      type       : 'slide',       
      perPage    : 3,
      gap        : '31px',
      perMove    : 1, 
      drag       : true,
      pagination : true,         
      arrows     : true,        
      breakpoints: {             
        480: {
          perPage: 1,
          pagination : true,         
          arrows     : true,
          drag       : true,
        },          
        767: {
          perPage: 2,
          pagination : false,         
          arrows     : true,
          drag       : true,
        },
        989: {
          perPage: 3,
          pagination : false,         
          arrows     : true,
          drag       : true,
          gap        : '20px',
        },
      },
    }).mount();
  });
}


class faqBlock extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const itemWrapper = this.querySelectorAll('.item_wrapper'); 
      itemWrapper.forEach((item, index) => {
        const title = item.querySelector('.item_heading');
        const content = item.querySelector('.item_content');
        title.addEventListener('click', () => {
            item.classList.toggle('active');
 
            if (item.classList.contains('active')) {
                content.style.maxHeight = content.scrollHeight + 'px';
            } else {
                content.style.maxHeight = null;
            }
 
            
            itemWrapper.forEach(otherItem => {
                if (otherItem !== item && otherItem.classList.contains('active')) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.item_content').style.maxHeight = null;
                }
            });
        });
 
       if (index === 0) {
            item.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
        }
      }); 
    }
}
customElements.define('faq-block', faqBlock);
